import React from 'react';
import Reauth from '../../reauth/src/index'//'reauth-private'

import { Localize } from "./localize.js";

//import { AuthLoginButton } from "./user-login.jsx";

let loginFields = [
  { name: 'email', type: 'email', label: 'Email', autoComplete: 'email', pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/ },
  {
    name: 'password', type: 'password', label: Localize.L("Password"), autoComplete: 'current-password' },
  { name: 'remember', type: 'checkbox', label: Localize.L("Ricordami") }
];

let registrationFields = [
  { name: 'company', type: 'hidden', label: Localize.L("Company") },
  { name: 'name', type: 'hidden', label: Localize.L("Name") },
  { name: 'email', type: 'email', label: Localize.L("Email"), autoComplete: 'email', pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/ },
  { name: 'password', type: 'password', label: Localize.L("Password") },
  { name: 'terms', type: 'checkbox', label: Localize.L("Acconsento al trattamento dei miei dati personali ai sensi dell\'art. 13 del D.Lgs. 30/06/2003 n°196.") },
  { name: 'phone', type: 'text', label: Localize.L("Numero di telefono") }
];

class LoginDropdown extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {

    // parent node <li class="nav-item dropdown">

    return (
        <Reauth
          //onAuth={(response, provider) => { console.log([response, provider]); }}
          oSignup={(response, provider) => { window.location.reload() }}
          endpoint={"/"}
          component="a"
          componentClass="nav-link ddropdown-toggle"
          componentText={Localize.L("Accedi")}
          componentFaIconClass="fas fa-sign-in-alt"

          loginFields={loginFields}
          registrationFields={registrationFields}
        />
    );

    //return (
    //  <li className="nav-item dropdown">
    //    <a className="nav-link ddropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"
    //      name="LoginDropdown"
    //      onClick={(e) => this.props.toggle(e)}><i className="fas fa-sign-in-alt" />
    //      <Reauth
    //        //onAuth={(response, provider) => { console.log([response, provider]); }}
    //        oSignup={(response, provider) => { window.location.reload() }}
    //        endpoint={"/"}
    //        component="button"
    //        componentClass=""
    //        componentText="Accedi"

    //        loginFields={loginFields}
    //        registrationFields={registrationFields}
    //      />
    //    </a>
    //  </li>
    //);

    //return (
    //  <li className="nav-item dropdown">
    //    <a className="nav-link ddropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"
    //      name="LoginDropdown"
    //      onClick={(e)=> this.props.toggle(e)}><i className="fas fa-sign-in-alt" /> Accedi</a>
    //    <div className="dropdown-menu" style={{ fontSize: '100%', display: this.props.show ? "block" : "none" }}>
    //      <a className="dropdown-item" href="#" id="googleSigninButton"><i className="fab fa-google fa-lg fa-fw" aria-hidden="true" style={{ color: '#dd4b39' }} /> Accedi con Google</a>
    //      <div className="dropdown-divider" />
    //      <a className="dropdown-item" href="#" id="facebookSigninButton"><i className="fab fa-facebook-f fa-lg fa-fw" aria-hidden="true" style={{ color: '#3b5998' }} /> Accedi con Facebook</a>
    //      <div className="dropdown-divider" />
    //      <AuthLoginButton />
    //      <div className="dropdown-divider" />
    //      <a className="dropdown-item mini" href="#">If you prefer you can sign up<br />choosing your user and password</a>
    //      <a className="dropdown-item" href="/join"><i className="far fa-hand-point-right fa-lg fa-fw" aria-hidden="true" /> Join</a>
    //    </div>
    //  </li>
    //);
  }
}

export { LoginDropdown }
